import { render, staticRenderFns } from "./header-notifications.vue?vue&type=template&id=d5bcc40c&scoped=true"
import script from "./header-notifications.vue?vue&type=script&lang=js"
export * from "./header-notifications.vue?vue&type=script&lang=js"
import style0 from "./header-notifications.vue?vue&type=style&index=0&id=d5bcc40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bcc40c",
  null
  
)

export default component.exports